import { render, staticRenderFns } from "./pubNoticeDetail.vue?vue&type=template&id=4544b216&scoped=true&"
import script from "./pubNoticeDetail.vue?vue&type=script&lang=js&"
export * from "./pubNoticeDetail.vue?vue&type=script&lang=js&"
import style0 from "./pubNoticeDetail.vue?vue&type=style&index=0&id=4544b216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4544b216",
  null
  
)

export default component.exports